import { FC, useMemo } from 'react';
import { get } from 'lodash';

import { Route, useRoute } from '@core/navigation';
import { RoutePath } from '@common/constants';
import { Page } from '@wearehelpful/ui-kit';
import { useGetSurveyQuery, useGetSurveys } from '@helpful/network';

import { DetailsContext } from './Details.context';
import { Questions } from './Questions/Questions';
import { Index } from './Index/Index';
import { Success } from './Success/Success';

export const Details: FC = () => {
  const [{ params }] = useRoute<{ slug?: string }>();

  const { data: surveyData, isLoading: isSurveyLoading } = useGetSurveyQuery({
    slug: params.slug,
  });

  const { data: uncomletedData, isLoading: isUncompletedLoading } =
    useGetSurveys({
      take: 1,
      filter: {
        isCompleted: 'false',
        slug: params.slug,
      },
      order: 'createdAt:DESC',
    });

  const uncomleted = useMemo(
    () => get(uncomletedData, ['data', 0]),
    [uncomletedData]
  );

  const survey = useMemo(
    () => get(surveyData, ['surveyCollection', 'items', 0]),
    [surveyData]
  );

  const loading = isSurveyLoading || isUncompletedLoading;

  return (
    <Page key={params.slug}>
      <DetailsContext.Provider value={{ survey, loading, uncomleted }}>
        <Route path={RoutePath.SURVEYS_DETAILS} exact>
          <Index />
        </Route>
        <Route path={RoutePath.SURVEYS_DETAILS_QUESTIONS}>
          <Questions />
        </Route>
        <Route path={RoutePath.SURVEYS_DETAILS_SUCCESS}>
          <Success />
        </Route>
      </DetailsContext.Provider>
    </Page>
  );
};
